var map = {
	"./Union.svg": 4986,
	"./activation-limit.svg": 1066,
	"./application-record.svg": 5799,
	"./back.svg": 611,
	"./borrow-money.svg": 8660,
	"./bulb.svg": 3088,
	"./check-circle.svg": 9229,
	"./close.svg": 9048,
	"./fail-warn.svg": 6495,
	"./gold.svg": 1299,
	"./home.svg": 7407,
	"./icon-warn.svg": 5212,
	"./immediate-withdrawal.svg": 3840,
	"./input-phone.svg": 8799,
	"./jufu-haier-text-logo.svg": 2067,
	"./jufu-jurongyi-text-logo.svg": 9675,
	"./jufu-text-logo.svg": 4824,
	"./lightning.svg": 4988,
	"./lock.svg": 8471,
	"./money-collect.svg": 4155,
	"./my.svg": 1121,
	"./personal-data.svg": 2304,
	"./purse.svg": 6550,
	"./rocket.svg": 8218,
	"./safety.svg": 6347,
	"./sound.svg": 9878,
	"./xiangbei-close.svg": 4711,
	"./xiangbei-handshake.svg": 2921,
	"./xiangbei-phone.svg": 3788,
	"./xiangbei-user.svg": 6815,
	"./youqianqianbao-text.svg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 401;